/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  authenticated(state) {
    return state.token;
  },
  userRole(state) {
    if (!state.token) return null;
    try {
      const payload = JSON.parse(atob(state.token.split(".")[1]));
      return payload.role;
    } catch (e) {
      return null;
    }
  },
};
